import { z } from 'zod';

export const ClientPreferenceSchema = z.object({
    layout: z.union([z.literal('light'), z.literal('advanced')]),
});
